import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useAuth } from "../store/authContext";

export default function Signup() {
  const navigate = useNavigate();
  const { register: registerAuth } = useAuth();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { register: registerForm, handleSubmit, formState: { errors }, watch } = useForm();

  const password = watch("password");

  const onSubmit = async (data: any) => {
    setIsLoading(true);
    setError("");
    try {
      await registerAuth(data.email, data.password, data.firstName);
      navigate("/");
    } catch (err: any) {
      setError(err.message || "Registration failed. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Create your account</h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Already have an account?{" "}
            <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500">
              Sign in
            </Link>
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
          {error && <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded">{error}</div>}
          
          <div>
            <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">First Name (optional)</label>
            <input id="firstName" type="text" {...registerForm("firstName")} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md" />
          </div>

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
            <input id="email" type="email" {...registerForm("email", { 
              required: "Email is required",
              pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Invalid email address" }
            })} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md" />
            {errors.email && <p className="mt-1 text-sm text-red-600">{String(errors.email.message)}</p>}
          </div>

          <div>
            <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
            <input id="password" type="password" {...registerForm("password", { 
              required: "Password is required",
              minLength: { value: 8, message: "Password must be at least 8 characters" }
            })} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md" />
            {errors.password && <p className="mt-1 text-sm text-red-600">{String(errors.password.message)}</p>}
          </div>

          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700">Confirm Password</label>
            <input id="confirmPassword" type="password" {...registerForm("confirmPassword", { 
              required: "Please confirm your password",
              validate: value => value === password || "Passwords do not match"
            })} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md" />
            {errors.confirmPassword && <p className="mt-1 text-sm text-red-600">{String(errors.confirmPassword.message)}</p>}
          </div>

          <button type="submit" disabled={isLoading} className="w-full py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 disabled:opacity-50">
            {isLoading ? "Creating account..." : "Create account"}
          </button>
        </form>
      </div>
    </div>
  );
}
